import { IEvent } from "@quest/adapter-interface";
import { detectDeviceEnvironmentConstants, dispatcher, ingenuity } from "@quest/base-core";
import {
  BaseViewBehavior,
  SlotEventConstantsBehavior,
} from "@quest/murka-games-behavior-panther";

export class CollectionBannerView extends BaseViewBehavior {
  constructor(view: any) {
    super(view);
  }
  /**
   * to add view on top
   */
  public addViewToTop(): void {
    ingenuity.currentGame.stage.addChild(this);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
  }

  protected resize(evt: IEvent): void {
    super.resize(evt);
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      let scale = 0;
      this.pivot.set(ingenuity.configData.height / 2, ingenuity.configData.width / 2);
      scale = Math.max(innerHeight / ingenuity.configData.width, innerWidth / ingenuity.configData.height);
      this.scale.set(scale);
    }
  }
}
